import type { ApiConfig } from './config.base';
import { config as devConfig } from './config.dev';
import { config as prodConfig } from './config.prod';
import { config as localConfig } from './config.local';

export const API_CONFIG: ApiConfig =
    import.meta.env.MODE === 'production'
        ? prodConfig
        : import.meta.env.MODE === 'development'
            ? devConfig
            : localConfig